import axios, { ApiResponse, ApiRoutes, ErrorResponse } from "@/api/client";
import { Organization } from "@/types";

const getOrg: () => Promise<Organization> = () => {
  return axios
    .get(ApiRoutes.ORGS)
    .then((response: ApiResponse<{ organization: Organization }>) => {
      return response.data.data.organization;
    })
    .catch((reason: ErrorResponse) => {
      const e = {
        error: {
          message: reason.response?.data?.message || "Failed to fetch organization details.",
          suppressGlobalNotification: true,
          statusCode: reason.response?.status,
        },
      };
      throw e;
    });
};

const OrgService = {
  getOrg,
};
export default OrgService;
